import { ArrowUpRight } from 'lucide-react';
import { type SyntheticEvent, useEffect, useState } from 'react';
import { loadIdeaIdentity, sendAppIdea } from '../lib/idea-api';

export function IdeaForm() {
  const [idea, setIdea] = useState('');
  const [email, setEmail] = useState('');
  const [emailFromDropbox, setEmailFromDropbox] = useState(false);
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState('Sent here in BuckSimple — no email app opens.');

  useEffect(() => {
    void loadIdeaIdentity().then((identity) => {
      if (!identity.email) return;
      setEmail(identity.email);
      setEmailFromDropbox(true);
    }).catch(() => undefined);
  }, []);

  async function sendIdea(event: SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();
    const cleanIdea = idea.trim();
    if (!cleanIdea) {
      setMessage('Tell us the little job you want the app to do.');
      return;
    }
    if (!email.trim()) {
      setMessage('Enter your email so Rob can reply.');
      return;
    }
    setSending(true);
    setMessage('Sending…');
    try {
      await sendAppIdea({ idea: cleanIdea, replyEmail: email });
      setIdea('');
      setMessage('Thanks — Rob has your idea.');
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Your idea could not be sent. Please try again.');
    } finally {
      setSending(false);
    }
  }

  return (
    <form className="idea-form" onSubmit={sendIdea}>
      <p className="eyebrow">WANT ANOTHER SIMPLE APP?</p>
      <label htmlFor="app-idea">What should it do?</label>
      <label className="idea-email" htmlFor="app-idea-email">
        Your email
        <input id="app-idea-email" type="email" maxLength={254} required readOnly={emailFromDropbox} value={email} onChange={(event) => setEmail(event.target.value)} placeholder="you@example.com" autoComplete="email" />
        {emailFromDropbox ? <span>From your connected Dropbox account</span> : null}
      </label>
      <div className="idea-row">
        <input
          id="app-idea"
          name="idea"
          type="text"
          maxLength={300}
          value={idea}
          onChange={(event) => setIdea(event.target.value)}
          placeholder="Example: rename ten files at once"
          autoComplete="off"
        />
        <button type="submit" disabled={sending}>{sending ? 'Sending…' : 'Send'} <ArrowUpRight aria-hidden="true" /></button>
      </div>
      <p className="form-note" aria-live="polite">{message}</p>
    </form>
  );
}
